// Note: Dynamic classnames are only supported here because they are pre-generated in the tailwind.config.js file
interface Props {
  label: string;
  value: string;
}

const bgColorClassname = (backgroundColor: Props) => {
  return backgroundColor?.label ? `bg-${backgroundColor.label}` : '';
};

export default bgColorClassname;
